import React from 'react';

const AnimatedDigit = ({ value, prev }: { value: string; prev: string }) => {
  return (
    <div
      className="tw-relative tw-inline-block tw-h-[1.2em] tw-overflow-hidden tw-min-w-[0.4em]"
      data-testid="animated-digit"
    >
      <div
        key={value}
        className="tw-absolute tw-bottom-0 tw-w-full tw-animate-slideDown tw-opacity-100"
      >
        {value}
      </div>
      {prev !== value && (
        <div key={`prev-${prev}`} className="tw-absolute tw-w-full tw-animate-slideUp tw-opacity-0">
          {prev}
        </div>
      )}
    </div>
  );
};

export default AnimatedDigit;
